import { useCurrencyFormatter } from '../../../shared/utils/currencyUtils'

interface TotalCellProps {
  amount: number
}

export const TotalCell = ({ amount }: TotalCellProps) => {
  const { formatPrice } = useCurrencyFormatter()
  
  return (
    <span
      className="font-semibold text-[16px]"
      style={{
        lineHeight: '140%',
        letterSpacing: '0%',
        background: 'linear-gradient(0deg, #3F3E42, #3F3E42), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }}
    >
      {formatPrice(amount)}
    </span>
  )
}